import { computed, ComputedRef, Ref } from 'vue'

import { CollectorSport } from '@mobile/reusables/classes/CollectorSport'
import { BasketballConfiguration } from '@mobile/views/Relation/DetailsPanel/Sports/Basketball/BasketballConfiguration'
import { SoccerConfiguration } from '@mobile/views/Relation/DetailsPanel/Sports/Soccer/SoccerConfiguration'

import { ListOption } from './types'
import {
  getAttributesConfiguration,
  getDetailsConfiguration,
  getDetailsIncidentsFilterValues,
  getHideIncidentsFilterValues,
  getManualAddIncidentModalStatuses,
  getManualAddIncidents,
  getManualAddSubstitutionIncidents,
  getParticipantIncidentsFilterValues,
  getSecondParticipantIncidents,
  getSelectedOnStartDetailsIncidents,
  mapIncidents,
  shouldReversePagination,
  shouldShowCurrentPeriodResult,
} from './utils'

export const GroupNames = {
  ...SoccerConfiguration.groupNames,
  ...BasketballConfiguration.groupNames,
}

export type SportOptionsComposable = ReturnType<typeof useSportOptions>

/* eslint-disable-next-line @typescript-eslint/explicit-function-return-type */
export function useSportOptions(sport: ComputedRef<CollectorSport>) {
  const hideIncidentsOptions: Ref<ListOption[]> = computed(() =>
    mapIncidents(
      getHideIncidentsFilterValues,
      sport.value.incidents,
      sport.value.sportsAPIEntity.id,
    ),
  )

  const participantIncidentsOptions: Ref<ListOption[]> = computed(() =>
    mapIncidents(
      getParticipantIncidentsFilterValues,
      sport.value.incidents,
      sport.value.sportsAPIEntity.id,
    ),
  )

  const detailsIncidentsOptions: Ref<ListOption[]> = computed(() =>
    mapIncidents(
      getDetailsIncidentsFilterValues,
      sport.value.incidents,
      sport.value.sportsAPIEntity.id,
    ),
  )

  const manualAddIncidents: Ref<ListOption[]> = computed(() =>
    mapIncidents(
      getManualAddIncidents,
      sport.value.incidents,
      sport.value.sportsAPIEntity.id,
    ),
  )

  const manualAddSubstitutionIncidents: Ref<ListOption[]> = computed(() =>
    mapIncidents(
      getManualAddSubstitutionIncidents,
      sport.value.incidents,
      sport.value.sportsAPIEntity.id,
    ),
  )

  const eventStatuses: Ref<ListOption[]> = computed(() =>
    mapIncidents(
      getManualAddIncidentModalStatuses,
      sport.value.statuses,
      sport.value.sportsAPIEntity.id,
    ),
  )

  const secondParticipantIncidents = getSecondParticipantIncidents(
    sport.value.sportsAPIEntity.id,
  )

  const detailsConfiguration = getDetailsConfiguration(
    sport.value.sportsAPIEntity.id,
  )

  const attributesConfiguration = getAttributesConfiguration(
    sport.value.sportsAPIEntity.id,
  )

  const selectedOnStartDetailsIncidents = getSelectedOnStartDetailsIncidents(
    sport.value.sportsAPIEntity.id,
  )

  const showCurrentPeriodResult = shouldShowCurrentPeriodResult(
    sport.value.sportsAPIEntity.id,
  )

  const reversePagination = shouldReversePagination(
    sport.value.sportsAPIEntity.id,
  )

  return {
    hideIncidentsOptions,
    participantIncidentsOptions,
    detailsIncidentsOptions,
    manualAddIncidents,
    eventStatuses,
    detailsConfiguration,
    manualAddSubstitutionIncidents,
    attributesConfiguration,
    secondParticipantIncidents,
    selectedOnStartDetailsIncidents,
    showCurrentPeriodResult,
    reversePagination,
  }
}
